import { Label as LabelRoot } from 'radix-ui';
import type { Label as LabelNS } from 'radix-ui';
import { forwardRef } from 'react';
export interface IBaseLabelProps extends LabelNS.LabelProps {}

export const BaseLabel = forwardRef<
  HTMLLabelElement,
  IBaseLabelProps
  // eslint-disable-next-line no-restricted-syntax
>(function BaseLabel({ ...props }, ref): JSX.Element {
  return <LabelRoot.Root {...props} ref={ref} />;
});
